import React from 'react';
import { Box, Radio, Typography } from '@mui/material';
import { Controller } from 'react-hook-form';
import { QUIZ_TRUE_FALSE_ANSWERS, QUIZ_TRUE_FALSE_LOCKED } from '../../common/constants';

/**
 * The answers of a True/False question: the two words are fixed, so they are
 * shown rather than edited. The radio beside each one marks which of them the
 * quiz grades against, the same way a multiple choice answer is marked — a
 * generated question's answer key is no less worth correcting for being
 * generated.
 *
 * Props:
 *   id             (string) - ID prefix for generated element IDs.
 *   control        (object) - react-hook-form control for the editor's form.
 *   name           (string) - Field path of the question these answers belong to.
 *   questionNumber (number) - Used for the accessible labels.
 */
export const TrueFalseAnswers = ({ id, control, name, questionNumber }) => (
  <Controller
    name={`${name}.correctIndex`}
    control={control}
    render={({ field }) => (
      <>
        <Typography className="trueFalseNotice">{QUIZ_TRUE_FALSE_LOCKED}</Typography>

        <Box
          className="trueFalseAnswers"
          role="radiogroup"
          aria-label={`Question ${questionNumber} correct answer`}
        >
          {QUIZ_TRUE_FALSE_ANSWERS.map((text, index) => {
            const isCorrect = field.value === index;

            return (
              <Box className="trueFalseRow" key={text}>
                <Radio
                  id={`${id}__radio_answer_${index + 1}`}
                  checked={isCorrect}
                  onChange={() => field.onChange(index)}
                  size="small"
                  slotProps={{
                    input: {
                      'aria-label': `Mark ${text} as the correct answer to question ${questionNumber}`,
                    },
                  }}
                />

                {/* Shown, not edited: the word itself is what makes it True/False. */}
                <Typography className={`trueFalseAnswer ${isCorrect ? 'correct' : ''}`}>
                  {text}
                </Typography>
              </Box>
            );
          })}
        </Box>
      </>
    )}
  />
);
